import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from "react";
export const VersionListContentHeader = /*#__PURE__*/ memo((param)=>{
    let { hasOtherVersions } = param;
    return /*#__PURE__*/ _jsxs("div", {
        className: "mb-2 flex w-full items-center justify-start",
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "mr-8 flex h-5 w-[120px] items-center justify-start pl-1",
                children: /*#__PURE__*/ _jsx("div", {
                    className: "text-10 font-bold text-grey-9",
                    children: "COVER"
                })
            }),
            hasOtherVersions && /*#__PURE__*/ _jsx("div", {
                className: "flex h-5 items-center justify-start pl-1",
                children: /*#__PURE__*/ _jsx("div", {
                    className: "text-10 font-bold text-grey-9",
                    children: "OTHER VERSIONS"
                })
            })
        ]
    });
});
VersionListContentHeader.displayName = "VersionListContentHeader";
